<template>
  <div id="logon">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="logo">
      <img src="/static/img/loginlogo.png" alt="logo">
    </div>
    <div class="content">
      <div class="select">
        <i class="iconfont">&#xe610;</i>
        <input type="tel" placeholder="请输入用户名/邮箱/手机号" v-model="username">
      </div>
      <div class="select select-box select-password">
        <i class="iconfont">&#xe619;</i>
        <input type="password" placeholder="请输入密码" v-model="password">
      </div>
      <!-- <div class="select select-box select-identify">
        <i class="iconfont">&#xe606;</i>
        <input type="text" placeholder="请输入验证码" v-model="validate">
        <img src="/static/img/验证码.jpg" alt="验证码">
      </div> -->
    </div>
    <div class="footer">
      <div class="log-on">
        <p class="agreement">登录即代表您已阅读并同意<router-link tag="span" to="/service">《爱易货平台服务条款》</router-link><router-link tag="span" to="/secret">《隐私条款》</router-link></p>
        <div>
          <button type="submit" @click="handleSubClick">{{state}}</button>
          <p class="forget" @click="goForgetPassword">忘记密码？</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'
export default {
  name: 'LogonLogmess',
  data () {
    return {
      state: '登录',
      username: '',
      password: '',
      validate: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleSubClick () {
      // 登录
      if (this.username === '') {
        alert('用户名不能为空哦~~')
        if (this.password === '') {
          alert('密码不能为空哦~~')
        }
      } else if (this.password === '') {
        alert('密码不能为空哦~~')
      }
      // 提示
      this.state = '登录中...'
      this.bus.$emit('loading', true)
      this.logonvalidate()
      // 反馈
    },
    // 验证
    logonvalidate () {
      this.axios.post('/ApiAccount/Login', {
        UserName: this.username,
        Password: this.password
      }).then(this.postLogInfoSucc)
        .catch(this.postLogInfoFail)
    },
    // 提交
    postLogInfoSucc (res) {
      this.state = '再次登录'
      res = res.data
      if (res.ret && res.okInfo === 'succeed') {
        // console.log('登录成功')
        let redirect = this.$route.query.redirect
        let redirext = redirect || '/me'
        this.$router.push({
          path: redirext
        })
        this.bus.$emit('loading', false)
        this.$store.commit(types.LOGIN, res.token)
      } else {
        alert(res.errorInfo)
        this.bus.$emit('loading', false)
      }
    },
    postLogInfoFail (err) {
      console.log(err)
    },
    goForgetPassword () {
      this.$router.push({
        path: '/forget_password'
      })
    }
  }
}
</script>

<style scoped>
#logon{ min-height: 100%;}
.header{ padding: 10px 15px;}
.header .iconfont{ font-size: 25px;}
.header h1{ color: #3e3e3e; margin-left: 35px; margin-top: 10px;}
.logo{ margin: 50px 0;}
.logo img{ width: 80px; height: 80px; display: block; margin: 0 auto;}
.select{ margin-left: auto; margin-right: auto; padding-bottom: 5px; border-bottom: 1px solid #f6f6f5; width: 85%;}
.content{ margin-top: 30px;}
.content input{ border: 0; width: 78%; line-height: 20px;}
input::-webkit-input-placeholder{ color:#dedede; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.content .iconfont{ font-size: 17px; margin-left: 5px; color: #c9c7c7;}
.select-box{ margin-top: 30px;}
.select-password .iconfont{ font-size: 20px;}
.select-identify{ display: flex; padding: 0; margin-top: 16px;}
.select-identify img{ width: 41%; height: auto;}
.select-identify .iconfont{ line-height: 46px; margin-right: 6px;}
.log-on{ width: 85%; margin: 10px auto;}
.agreement{ font-size: 12px; color: #666;}
.agreement span{ color: #333;}
.footer button{ width: 100%; height: 38px; background-color: #f70f0f; border: 0; color: #fff; margin: 5px 0; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.other-way{ display: flex; justify-content: space-between;}
.footer a{ text-decoration: none;}
.forget{ text-align: right; color: #666;}
</style>



// WEBPACK FOOTER //
// src/pages/log_on/components/Logmess.vue